"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIDropdownCaret = _interopRequireDefault(require("../../dropdown/UIDropdownCaret"));

var _default = (0, _styledComponents.default)(_UIDropdownCaret.default).withConfig({
  displayName: "SimpleStyledCaret",
  componentId: "sc-18x0bxy-0"
})(["color:", ";"], _colors.EERIE);

exports.default = _default;
module.exports = exports.default;